import { render } from "./InformacionGeneralInspeccionView.vue?vue&type=template&id=21a88369"
import script from "./InformacionGeneralInspeccionView.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralInspeccionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__